import { render } from "./TheTable.vue?vue&type=template&id=8ba22da0&scoped=true&lang=pug"
import script from "./TheTable.vue?vue&type=script&lang=js"
export * from "./TheTable.vue?vue&type=script&lang=js"

import "./TheTable.vue?vue&type=style&index=0&id=8ba22da0&lang=scss&scoped=true"

import exportComponent from "/builds/fenix/ais-abr/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8ba22da0"]])

export default __exports__